import _defineProperty from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty";
import React from "react";
var __jsx = React.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Dialog } from '@material-ui/core';
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { AffiliationBlockType } from '@uno/common-cms';
import { GradientButton } from 'components/common/material-ui/custom-components';
import { ButtonContainer, CloseButton, Description, Title } from './AffiliationBlockDialog.style';
import { AffiliationBlockTypeCta, AffiliationBlockTypePriceTable } from './AffiliationBlockType';
import AffiliationBlockTypeSlideshow from './AffiliationBlockType/AffiliationBlockTypeSlideshow/AffiliationBlockTypeSlideshow';
import AffiliationBlockTypeSelection from './AffiliationBlockTypeSelection/AffiliationBlockTypeSelection';

var AffiliationBlockDialog = function AffiliationBlockDialog(_ref) {
  var open = _ref.open,
      onClose = _ref.onClose,
      onConfirm = _ref.onConfirm,
      initialAffiliationData = _ref.initialAffiliationData;

  var _useState = useState({
    blockType: initialAffiliationData === null || initialAffiliationData === void 0 ? void 0 : initialAffiliationData.type,
    blockTypeValidated: (initialAffiliationData === null || initialAffiliationData === void 0 ? void 0 : initialAffiliationData.type) !== undefined
  }),
      affiliationBlock = _useState[0],
      setAffiliationBlock = _useState[1];

  var selectBlockType = function selectBlockType(type) {
    setAffiliationBlock({
      blockType: type,
      blockTypeValidated: false
    });
  };

  var handleNextStep = function handleNextStep() {
    setAffiliationBlock(function (prevValue) {
      return _objectSpread(_objectSpread({}, prevValue), {}, {
        blockTypeValidated: true
      });
    });
  };

  var affiliationBlockTypeEdition = function affiliationBlockTypeEdition(type) {
    switch (type) {
      case AffiliationBlockType.Cta:
      default:
        return __jsx(AffiliationBlockTypeCta, {
          initialLinkData: initialAffiliationData,
          onConfirm: onConfirm
        });

      case AffiliationBlockType.PriceTable:
        return __jsx(AffiliationBlockTypePriceTable, {
          initialLinkData: initialAffiliationData,
          onConfirm: onConfirm
        });

      case AffiliationBlockType.Slideshow:
        return __jsx(AffiliationBlockTypeSlideshow, {
          initialLinkData: initialAffiliationData,
          onConfirm: onConfirm
        });
    }
  };

  return __jsx(Dialog, {
    open: open,
    onClose: onClose,
    disableRestoreFocus: true,
    "data-testid": "affiliation-block-dialog"
  }, __jsx(CloseButton, {
    onClick: onClose,
    "data-testid": "close-button"
  }), __jsx(FormattedMessage, {
    id: "affiliation-block-modal.title",
    tagName: Title
  }), affiliationBlock.blockType === undefined || affiliationBlock.blockTypeValidated === false ? __jsx(React.Fragment, null, __jsx(FormattedMessage, {
    id: "affiliation-block-modal.description",
    tagName: Description
  }), __jsx(AffiliationBlockTypeSelection, {
    onClick: selectBlockType,
    selectedType: affiliationBlock.blockType
  }), __jsx(ButtonContainer, null, __jsx(GradientButton, {
    disabled: affiliationBlock.blockType === undefined,
    onClick: handleNextStep
  }, __jsx(FormattedMessage, {
    id: "affiliation-block-modal.next-step"
  })))) : __jsx(React.Fragment, null, affiliationBlockTypeEdition(affiliationBlock.blockType)));
};

export default AffiliationBlockDialog;